import { Identifier } from '../../../common';
import { Event } from '../../event';
import type { IdentityLevel } from '..';

/**
 * IdentityLevelの整理.md「識別子 × イベント別の Level 分類」に基づくデフォルト。`eventType: '*'` は任意イベント。
 */
export const _DefaultLevels = [
  // L4 まだ未定義
  // L3（memberId は identityVerified の方が * より優先される想定）
  {
    identifierType: Identifier.Type.FromString('customerId'),
    eventType: Event.TypeExpression.FromString('*'),
    defaultLevel: 'L3',
  },
  {
    identifierType: Identifier.Type.FromString('memberId'),
    eventType: Event.TypeExpression.FromString('*'),
    defaultLevel: 'L3',
  },
  {
    identifierType: Identifier.Type.FromString('karteUserId'),
    eventType: Event.TypeExpression.FromString('*'),
    defaultLevel: 'L3',
  },
  {
    identifierType: Identifier.Type.FromString('contractId'),
    eventType: Event.TypeExpression.FromString('*'),
    defaultLevel: 'L3',
  },
  // L2
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('smsOpened'),
    defaultLevel: 'L2',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('contactCaseRetrievedOnVoicebot'),
    defaultLevel: 'L2',
  },
  {
    identifierType: Identifier.Type.FromString('email'),
    eventType: Event.TypeExpression.FromString('*'),
    defaultLevel: 'L2',
  },
  // L1
  {
    identifierType: Identifier.Type.FromString('karteVisitorId'),
    eventType: Event.TypeExpression.FromString('formSubmitted'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('karteVisitorId'),
    eventType: Event.TypeExpression.FromString('contactCaseCreated'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('karteVisitorId'),
    eventType: Event.TypeExpression.FromString('web_agent_thread_created'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('smsSent'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('voicebotCallStarted'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('vocAdded'),
    defaultLevel: 'L1',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('vocMetadataUpdated'),
    defaultLevel: 'L1',
  },
  // L0（temporaryUserIdentifiers 前提の行はドキュメント参照）
  {
    identifierType: Identifier.Type.FromString('karteVisitorId'),
    eventType: Event.TypeExpression.FromString('smsOpened'),
    defaultLevel: 'L0',
  },
  {
    identifierType: Identifier.Type.FromString('karteVisitorId'),
    eventType: Event.TypeExpression.FromString('contactCaseRetrievedOnVoicebot'),
    defaultLevel: 'L0',
  },
  {
    identifierType: Identifier.Type.FromString('phone'),
    eventType: Event.TypeExpression.FromString('contactCaseCreated'),
    defaultLevel: 'L0',
  },
] satisfies {
  identifierType: Identifier.Type;
  eventType: Event.TypeExpression;
  defaultLevel: IdentityLevel;
}[];
